import React from 'react';

import { useIntl } from 'react-intl';

import DrawerPage from 'components/layout/drawer-page';

import { Configs } from './views/configs';

export default function DiagnosticsScreen() {
  const { formatMessage } = useIntl();

  return (
    <DrawerPage headerText={formatMessage({ id: 'diagnostics' })}>
      <Configs />
    </DrawerPage>
  );
}
